var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#B350FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55014 11.3228C6.37115 11.1438 6.37115 10.8536 6.55014 10.6746C6.72913 10.4957 7.01933 10.4957 7.19832 10.6746L9.62423 13.1006L14.8001 7.92465C14.9791 7.74566 15.2693 7.74566 15.4483 7.92465C15.6273 8.10364 15.6273 8.39384 15.4483 8.57283L9.94832 14.0728C9.76933 14.2518 9.47913 14.2518 9.30014 14.0728L6.55014 11.3228Z",
    fill: "#9A40FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4466 7.57109C14.8208 7.19684 15.4276 7.19684 15.8019 7.57109C16.1761 7.94535 16.1761 8.55213 15.8019 8.92638L10.3019 14.4264C9.92762 14.8006 9.32084 14.8006 8.94658 14.4264L6.19658 11.6764C5.82233 11.3021 5.82233 10.6953 6.19658 10.3211C6.57084 9.94684 7.17762 9.94684 7.55187 10.3211L9.62423 12.3935L14.4466 7.57109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChecked);
export default __webpack_public_path__ + "static/media/ic_checked.4e7afcd3b2ef3868bbcdea08df479ac4.svg";
export { ForwardRef as ReactComponent };